const mutations = {
  setVariables(state, payload) {
    state.variables = payload;
  },
};

export default mutations;
